import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SecurityContextInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('tokenMotor');
    const plataforma = 'Admin';
    const ruta = request.body?.payload?.ruta ?? '';

    /** Enviamos la propiedad 'plataforma' y 'ruta' en lo headers en rutas especifícas */
    if (this.#updateServicesWithNotToken().some(route => route === ruta)) {

      const requestClonada = request.clone({
        setHeaders: {
          plataforma,
          ruta
        }
      });

      return next.handle(requestClonada);
    }


    if (!token || this.#servicesNotUpdated().some(service => request.url.includes(service))) {
      return next.handle(request);
    }


    const requestClonada = request.clone({
      setHeaders: {
        token,
        plataforma,
        ruta
      }
    });

    return next.handle(requestClonada);
  }

  #servicesNotUpdated() {
    return [
      'loginMotorAdmin',
      'cataloge',
      's3.amazonaws.com',
      '/api/v1/'
    ]
  }

  #updateServicesWithNotToken() {
    return [
      'sendUrlRestorePassword',
      'validaUrlToken',
      'updatePassword'
    ]
  }
}
